import React, { useMemo, useRef, useState } from 'react';
import { Modal } from "../../components/Modal";
import { Member } from '../../audience-api';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import { WhatsAppMarkdown } from '../../whats-markdown/WhatsAppMarkdown';
import { VariablePicker } from './VariablePicker';
import { ReactTooltip } from 'tooltip';

const defaultTemplate =
`Bom dia, *{{nome}}* ☀

Tudo bem com o senhor(a)?

Você ainda está interessado no curso *{{curso}}*?
Temos uma promoção este mês...`

export interface MemberNavigation {
    member: Member
    next?(): MemberNavigation
    prev?(): MemberNavigation
    hasNext: boolean
    hasPrev: boolean
    total: number
    current: number
}

export function createMemberNavigation(members:Member[], index:number = 0):MemberNavigation{
    return {
        current: index + 1,
        total: members.length,
        member: members[index],
        hasNext: index < members.length - 1,
        hasPrev: index > 0,
        next: () => createMemberNavigation(members, index + 1),
        prev: () => createMemberNavigation(members, index - 1),
    }
}

export function runTemplate(template:string, source:Record<string, any>){
    return template.replace(/\{\{(.+?)\}\}/g, function(m, key){
        key = key.toLocaleLowerCase();
        if(key in source)
            return source[key] as string;
        return '';
    });
}

export function PreviewMessage({template, member, onGPT}:{template:string, member: Member, onGPT?:() => void}){
    const message = useMemo(()=>{
        return runTemplate(template, member.sourceMap);
    }, [template, member])

    onGPT = null;

    return <div className='mt-4 break-word overflow-hidden clearfix'>
        {onGPT && <ReactTooltip className='float-end'  
             tooltip={<>Use o <b>ChatGPT</b> para melhorar o seu texto</>} 
             placement='top-end'
             delay={300}><button onClick={onGPT} className='btn btn-info'><i className='fa fa-wand-magic-sparkles'></i></button></ReactTooltip>}
        <WhatsAppMarkdown message={message} />
    </div>
}

function MessagePreviewModal({navigation, variables}:{navigation:MemberNavigation, variables: string[]}){
    const [message, setMessage] = useState(defaultTemplate)
    const [nav, setNav] = useState(navigation)
    const textRef = useRef<HTMLTextAreaElement>(null);
    return <>
        <VariablePicker setText={setMessage} variables={variables} textRef={textRef} />
        <textarea ref={textRef} rows={5} className='form-control mt-3' value={message} onChange={(e) => setMessage(e.target.value)} />
        <PreviewMessage template={message} member={nav.member} />
        <hr />
        <div className='members-nav text-center'>
            {nav.current} / {nav.total}  
            <button className='btn btn-primary ms-2' onClick={() => setNav(nav.prev())} disabled={!nav.hasPrev}><i className='fa fa-arrow-left'></i></button>
            <button className='btn btn-primary ms-2' onClick={() => setNav(nav.next())} disabled={!nav.hasNext}><i className='fa fa-arrow-right'></i></button>
        </div>
    </>
}

export function MessagePreview({onHide, navigation, variables}:{onHide:()=>void, navigation:MemberNavigation, variables: string[]}){
    return <Modal title="Preview de Mensagem" onHide={onHide} className='modal-primary'>
        <MessagePreviewModal navigation={navigation} variables={variables} />
    </Modal>
}